import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  File,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}filteredfiles`;

export interface FilterFacetValue {
  name: string;
  label?: string;
  included: boolean;
}

export interface FilterFilesCommandArgs {
  query?: string;
  pageSize?: number;
  page?: number;
  isDescending?: boolean;
  sort?: string;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
  sortOptions?: SortOption[];
  sellerId?: string;
  tenantId?: string;
}

async function filterFilesCommand({
  query,
  filters,
  page,
  pageSize,
  sort,
  isDescending,
  dateTimeFilters,
  sortOptions,
  groupedFilters,
  queryableFilters,
  sellerId,
  tenantId,
}: FilterFilesCommandArgs): Promise<
  BackResponse<SearchResultList<File>> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SearchResultList<File>>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        filters,
        page,
        pageSize,
        sort,
        isDescending,
        dateTimeFilters,
        sortOptions,
        groupedFilters,
        queryableFilters,
        sellerId,
        tenantId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default filterFilesCommand;
